<template>
  <v-container>
    <!-- <v-banner> -->

    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color: Red">
        {{ error.message }}
      </li>
    </ul>
    <v-img height="380px" width="380px">
      <!-- @dblclick="getPosOnDblClick" -->
      <l-map
        :zoom.sync="zoom"
        :options="mapOptions"
        :center="center"
        :min-zoom="minZoom"
        :max-zoom="maxZoom"
        @update:center="centerUpdate"
        style="height: 380px; width: 100%; z-index: 0"
      >
        <l-control-layers
          :position="layersPosition"
          :collapsed="true"
          :sort-layers="true"
        />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :token="token"
          layer-type="base"
        />
        <l-control-zoom :position="zoomPosition" />
        <v-locatecontrol />
        <l-control-attribution
          :position="attributionPosition"
          :prefix="attributionPrefix"
        />
        <l-control-scale :imperial="imperial" />
        <l-marker
          :visible="mymarker.visible"
          :draggable="mymarker.draggable"
          :lat-lng.sync="mymarker.position"
          :icon="mymarker.icon"
        >
          <l-popup :content="mymarker.tooltip" />
          <l-tooltip :content="mymarker.tooltip" />
        </l-marker>
        <l-layer-group
          v-for="item in stuff"
          :key="item.id"
          :visible.sync="item.visible"
          layer-type="overlay"
          name="Other pilots"
        >
          <l-layer-group :visible="item.markersVisible">
            <l-circle-marker
              v-for="marker in markers"
              :key="marker.id"
              :lat-lng="marker.center"
              :radius="marker.radius"
              :color="marker.color"
            >
              <l-popup :content="marker.tooltip" />
              <l-tooltip :content="marker.tooltip" />
            </l-circle-marker>
          </l-layer-group>
        </l-layer-group>
      </l-map>
    </v-img>
  </v-container>
</template>

<script>
// import axios from "axios";
import { latLngBounds } from "leaflet";
import { latLng } from "leaflet";
// import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol';
import Vue2LeafletLocatecontrol from "vue2-leaflet-locatecontrol/Vue2LeafletLocatecontrol";
import {
  LMap,
  LTileLayer,
  LMarker,
  //   LPolyline,
  LLayerGroup,
  LTooltip,
  LPopup,
  LControlZoom,
  LControlAttribution,
  LControlScale,
  LControlLayers,
  LCircleMarker,
} from "vue2-leaflet";
// import AddPositionHelp from "@/components/help/AddPositionHelp.vue";

const markers1 = [
  //   {
  //     position: { lng: -1.219482, lat: 47.41322 },
  //     visible: true,
  //     draggable: true
  //   },
  //   { position: { lng: -1.571045, lat: 47.457809 } },
  //   { position: { lng: -1.560059, lat: 47.739323 } },
];

const poly1 = [
  //   { lng: -1.219482, lat: 47.41322 },
  //   { lng: -1.571045, lat: 47.457809 },
  //   { lng: -1.560059, lat: 47.739323 },
  //   { lng: -1.219482, lat: 47.41322 }
];

const tileProviders = [
  {
    name: "OpenStreetMap",
    visible: false,
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    name: "OpenTopoMap",
    visible: true,
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    attribution:
      'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
  },
];

export default {
  name: "Example",
  props: {
    ilat: Number,
    ilng: Number,
    izoom: Number,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    // LPolyline,
    LLayerGroup,
    LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LCircleMarker,
    "v-locatecontrol": Vue2LeafletLocatecontrol,
  },
  data() {
    return {
      //   initialLocation: [59.93428, 30.335098],
      dialog: false,
      pid: Number,
      eventid: Number,
      statusResult: Number,
      statusResultMsg: String,
      loggedIn: false,
      cookieRegId: Number,
      cookieToken: Number,
      cancellink: { to: "/airbox/0" },
      isValid: true,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      disableSaveBtn: false,
      v0: true,
      acRules: [(v) => !!v || "Access code is required"],
      ac: null,
      eyevalue: true,
      keys: ["position", "tooltip"],
      center: [59.504, 9.9969],
      currentCenter: latLng(59.504, 9.9969),

      currentPos: latLng(59.504, 9.9969),

      opacity: 0.6,
      token: "your token if using mapbox",
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      zoom: 12,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: "topleft",
      attributionPosition: "bottomright",
      layersPosition: "topright",
      attributionPrefix: "Vue2Leaflet",
      imperial: false,
      Positions: ["topleft", "topright", "bottomleft", "bottomright"],
      tileProviders: tileProviders,
      pilotpositions: [],
      errors: [],
      mymarker: [],
      markers: [
        {
          id: "m1",
          //   position: { lat: 59.504, lng: 9.9969 },
          tooltip: "Grøtterud",
          //   draggable: false,
          //   visible: true,
          center: { lat: 59.504, lng: 9.9969 },
          //   center: [59.504, 9.9969],
          radius: 6,
          color: "red",
        },
      ],
      //   polylines: [
      //     {
      //       id: "p1",
      //       points: [
      //         { lat: 37.772, lng: -122.214 },
      //         { lat: 21.291, lng: -157.821 },
      //         { lat: -18.142, lng: -181.569 },
      //         { lat: -27.467, lng: -206.973 },
      //       ],
      //       visible: true,
      //     },
      //     {
      //       id: "p2",
      //       points: [
      //         [-73.91, 40.78],
      //         [-87.62, 41.83],
      //         [-96.72, 32.76],
      //       ],
      //       visible: true,
      //     },
      //   ],
      stuff: [
        {
          id: "s1",
          markers: markers1,
          polyline: { points: poly1, visible: true },
          visible: true,
          markersVisible: true,
        },
      ],
      //   bounds: latLngBounds(
      //     { lat: 51.476483373501964, lng: -0.14668464136775586 },
      //     { lat: 51.52948330894063, lng: -0.019140238291583955 }
      //   )
    };
  },
  methods: {
    alert(item) {
      alert("this is " + JSON.stringify(item));
    },

    getPosOnDblClick: function (e) {
      // alert(e);
      // console.log("e",e);
      // DENNE ER FJERNET 20.02.2026 - BENYTTER NÅ OnCenterUpdate
      console.log("lat", e.latlng.lat);
      console.log("lon", e.latlng.lng);
      const newMarker = {
        // position = this.currentCenter,
        position: { lat: e.latlng.lat, lng: e.latlng.lng },
        draggable: true,
        visible: true,
        tooltip: "You",
      };
      //   this.markers.push(newMarker);
      this.mymarker = newMarker;
      var pos = e.latlng;
      this.$emit("pos_changed", pos);
    },
    removeMarker: function (index) {
      this.markers.splice(index, 1);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
    },
    removeAllMarkers() {
      var array = this.markers;
      array.forEach((element) => {
        element.tooltip = "";
        this.markers.pop();
      });
    },
    removeMyMarker: function () {
      this.mymarker.tooltip = "";
      this.mymarker.position = { lat: 0, lng: 0 };
      this.mymarker.visible = false;
    },
    fitPolyline: function () {
      const bounds = latLngBounds(markers1.map((o) => o.position));
      this.bounds = bounds;
    },
    centerUpdate(center) {
      this.currentCenter = center;
      // console.log("center", center.lat);
      const newMarker = {
        // position = this.currentCenter,
        position: { lat: center.lat, lng: center.lng },
        draggable: false,
        visible: true,
        tooltip: "You",
      };
      //   this.markers.push(newMarker);
      this.mymarker = newMarker;
      var pos = newMarker.position;
      // console.log("pos", pos);
      this.$emit("pos_changed", pos);
    },
    helpMe() {
      alert("Sorry, no help implemented yet! :)");
    },
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    // this.pid = 1;
    this.pid = this.$route.params.id;
    this.eventid = this.$route.params.eventid;
    if (this.pid === undefined) {
      this.pid = 0;
      // this.showessentials = false;
    }
    this.mymarker.tooltip = "";
    this.mymarker.position = { lat: 0, lng: 0 };
    this.mymarker.visible = false;
    this.center = latLng(this.ilat, this.ilng);
    this.zoom = this.izoom;

    // console.log("iLat",this.ilat);
    // this.getpositions();
    // this.getCookies();
  },
};
</script>

<style>
/* @import "~leaflet/dist/leaflet.css"; */
/* @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"; */
/* html,
body {
  height: 100%;
  margin: 0;
} */
</style>